import i18n from 'i18next';
import translations from 'src/internationalisation/translation-map.json';

export const CostType = Object.freeze({
  DayRate: 'dayRate',
  LumpSum: 'lumpSum',
  Quantity: 'quantity',
});

export const QuantityType = Object.freeze({
  Length: 'length',
  Volume: 'volume',
  ItemCount: 'itemCount',
  HoleVolume: 'holeVolume',
  HoleLength: 'holeLength',
});

export const TimeType = Object.freeze({
  DAYS: 'days',
  HOURS: 'hours',
});

export const CostTypeMap = Object.freeze({
  [CostType.DayRate]: i18n.t(translations.costSetup_dayRate),
  [CostType.LumpSum]: i18n.t(translations.costSetup_lumpSum),
  [CostType.Quantity]: i18n.t(translations.costSetup_quantity),
});
